// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cu","header":"cv","confirmHeader":"cw","title":"cx","description":"cy","subHeader":"cz","button":"cA"};